// Messages d'encouragement variés pour maintenir l'engagement de l'enfant

const successMessages = [
  "Bravo {name} ! C'est parfait !",
  "Excellent {name} ! Tu es un champion !",
  "Super {name} ! C'est très bien !",
  "Fantastique {name} ! Continue comme ça !",
  "Magnifique {name} ! Tu as tout compris !",
  "Bravo {name} ! Tu es très fort !",
  "Génial {name} ! C'est la bonne réponse !",
  "Wouah {name} ! Tu es incroyable !",
  "Parfait {name} ! Tu progresses tellement bien !",
  "Formidable {name} ! Quel talent !"
];

const encouragementMessages = [
  "Allez {name}, tu peux le faire !",
  "Courage {name}, tu es sur la bonne voie !",
  "N'abandonne pas {name}, tu vas y arriver !",
  "Réessaie {name}, tu es capable !",
  "Continue {name}, tu apprends tellement !",
  "Persévère {name}, c'est comme ça qu'on progresse !"
];

const errorMessages = [
  "Ce n'est pas ça {name}, mais tu vas y arriver !",
  "Pas tout à fait {name}, réessaie encore !",
  "Presque {name} ! Essaie encore une fois !",
  "Oups {name} ! Tu peux faire mieux !",
  "Ce n'est pas grave {name}, on apprend de ses erreurs !",
  "Raté {name}, mais tu progresses quand même !",
  "Dommage {name}, mais ne lâche rien !",
  "Pas cette fois {name}, mais tu vas réussir !",
  "Essaie encore {name}, tu es sur le bon chemin !",
  "Ce n'est pas la bonne réponse {name}, mais continue !"
];

export const getSuccessMessage = (childName) => {
  const randomMessage = successMessages[Math.floor(Math.random() * successMessages.length)];
  return childName ? randomMessage.replace('{name}', childName) : randomMessage.replace(' {name}', '');
};

export const getEncouragementMessage = (childName) => {
  const randomMessage = encouragementMessages[Math.floor(Math.random() * encouragementMessages.length)];
  return childName ? randomMessage.replace('{name}', childName) : randomMessage.replace(' {name}', '');
};

export const getErrorMessage = (childName) => {
  const randomMessage = errorMessages[Math.floor(Math.random() * errorMessages.length)];
  return childName ? randomMessage.replace('{name}', childName) : randomMessage.replace(' {name}', '');
};

export default {
  getSuccessMessage,
  getEncouragementMessage,
  getErrorMessage
};
